import { render, staticRenderFns } from "./CExpandableListItem.vue?vue&type=template&id=55624be7&scoped=true&"
import script from "./CExpandableListItem.vue?vue&type=script&lang=js&"
export * from "./CExpandableListItem.vue?vue&type=script&lang=js&"
import style0 from "./CExpandableListItem.vue?vue&type=style&index=0&id=55624be7&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55624be7",
  null
  
)

export default component.exports